import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  Button,
  Modal,
} from "react-bootstrap";
import {
  downloadProductsAction,
  submitJobAction,
} from "../../../state/cart/dispatchActions";
import Loader from "../Loader";
import {
  getMissionCodesByDescriptions,
  getScopeConfigurationFieldsBy,
  getSearchFormValuesByState,
} from "../../../helpers/configurationHelper";
import DynamicSearchField from "../dynamic-form/DynamicSearchField";
import { getMainInputConfigurationsBy } from "../../../helpers/searchHelper";
import {
  getMixedProductionFields,
  getProductionFieldsConfigurations,
  haveProductionFieldsBeenFilled
} from "../../../helpers/cartHelper";
import {Form as BootstrapForm} from "react-bootstrap"
import { DownloadType, JobType } from "../../../types/cart";
import {AdvancedSearchConfigurationsType, ConfigurationsType} from "../../../types/configurations";
import { ShapeType } from "../../../types/shape";
import { ProductImageStacType } from "../../../types/product";
import { hasBeenFilled } from "../../../helpers/dynamicFormHelper";
import InputText from "../inputs/InputText";
import {getDownloadErrorMessageBy, getErrorMessageFrom} from "../../../helpers/errorsHelper";
import { errorToastNotification } from "../../../helpers/toastNotificationHelper";
import { AppParametersType } from "../../../types/app";
import translations from "../../../translations";
import InputRadio from "../inputs/InputRadio";
import {updateSearchFiltersSelectedAction} from "../../../state/application/actions";
import AxiosServiceHandler from "../../../services/AxiosServiceHandler";
import CartService from "../../../services/CartService";

interface PropsType {
  configurations: ConfigurationsType;
  job: JobType | null,
  downloads: DownloadType[] | null,
  modalText?: string;
  selectedArea: ShapeType;
  selectedProducts: ProductImageStacType[];
  numberOfItems?: number;
  searchFormValues: any;
  createdOrdersActionHandler: any;
  downloadProductsActionHandler: any;
  submitJobActionHandler: any;
  handleClose: any;
  appParameters: AppParametersType;
  language: string;
  searchByProducts: boolean;
  formData: any;
  productionsFields: any;
}

export const CheckoutModal = (props: PropsType) => {
  const {
    configurations,
    job,
    downloads,
    modalText = "",
    selectedArea,
    selectedProducts,
    numberOfItems,
    searchFormValues,
    downloadProductsActionHandler,
    submitJobActionHandler,
    handleClose,
    appParameters,
    language,
    searchByProducts,
    formData,
    productionsFields
  } = props;

  const totalOrdersItemsCount = hasBeenFilled(numberOfItems)
    ? numberOfItems
    : selectedProducts.length;
  const mainInputConfigurations = getMainInputConfigurationsBy(configurations, appParameters);
  const scopeConfigurationFields =
    getScopeConfigurationFieldsBy(configurations);

  const [isProceeding, setIsProceeding] = useState(false);
  const [isLoadingModalBody, setIsLoadingModalBody] = useState(false);
  const [isForbiddenSubmit, setIsForbiddenSubmit] = useState(false);
  const [productionFields, setProductionFields] = useState<any>([]);
  const [summaryText, setSummaryText] = useState<string>(modalText);
  const [description, setDescription] = useState<string>("");

  const formProperties: string[] = [];
  const formValues: any = {};
  Object.keys(searchFormValues).forEach((key) => {
    formProperties.push(key);
  });
  selectedProducts.forEach((selectedProduct) => {
    if (selectedProduct.properties) {
      Object.keys(selectedProduct.properties as Object).forEach((key) => {
        if (formProperties.includes(key)) {
          if (!formValues.hasOwnProperty(key)) {
            formValues[key] = [];
          }
          formValues[key] = formValues[key].concat(selectedProduct.properties && selectedProduct.properties[key] ?
              [selectedProduct.properties[key]] : []);
        }
      });
    }
  });
  const searchFormAndSelectionValues = {...searchFormValues, ...formValues};

  useEffect(() => {
    if (downloads) {
      CartService.countDownloads().then((countResponse: any) => {
        const count = parseInt(countResponse.data);
        setIsLoadingModalBody(true);
        prepareProceed(count);
      }).catch((error => {
        errorToastNotification(getErrorMessageFrom(error, translations("errorsGettingCount", appParameters.language)), {hideAfter: 7})
      }));
    } else if (job) {
      CartService.countJobs().then((countResponse: any) => {
        const count = parseInt(countResponse.data);
        setIsLoadingModalBody(true);
        prepareProceed(count);
      }).catch((error => {
        errorToastNotification(getErrorMessageFrom(error, translations("errorsGettingCount", appParameters.language)), {hideAfter: 7})
      }));
    }
  }, [downloads, job]);

  const prepareProceed = (rateLimit: number | null) => {
    // lista delle missioni "selezionate"
    const selectedProductsMissionsList: any[] = [];
    const selectedProductsMissions = {};
    formData.missions.forEach(mission => { selectedProductsMissions[mission] = 0; });
    selectedProducts.forEach((product: any) => selectedProductsMissions[product.properties.mission]++);
    Object.keys(selectedProductsMissions).forEach(key => {
      if (selectedProductsMissions[key] > 0) {
        selectedProductsMissionsList.push(key);
      }
    });

    if (job) { // gestione dei parametri di produzione
      // preparing production fields
      const newProductionFieldsConfigurations =
          getProductionFieldsConfigurations(
              configurations,
              appParameters,
              mainInputConfigurations,
              scopeConfigurationFields,
              selectedArea,
              searchFormValues,
              selectedProducts,
              getMissionCodesByDescriptions(configurations as AdvancedSearchConfigurationsType, selectedProductsMissionsList)
          );
      const newProductionFields = getMixedProductionFields(newProductionFieldsConfigurations);
      setProductionFields(newProductionFields);

      const missionText = selectedProductsMissionsList.join(translations("and", language));
      const rateLimitText = rateLimit !== null && ((rateLimit - 1) < 0) ? " " + translations("jobLimitWarn", language).replace('${limit}', rateLimit) : "";
      setSummaryText(translations("submitJobSummary", language).replace('${scenes}', job.item_list.length).replace('${mission}', missionText) + rateLimitText);
      setIsLoadingModalBody(false);
      setIsForbiddenSubmit(rateLimit !== null && ((rateLimit - 1) < 0));
    } else if (downloads) { // gestione dei downloads
      const missionText = selectedProductsMissionsList.join(translations("and", language));
      // mostro rateLimitText solo se non riesco a scaricare tutti i selezionati
      const rateLimitText = rateLimit !== null && ((rateLimit - downloads.length) < 0) ? " " + translations("dowloadLimitWarn", language).replace('${limit}', rateLimit) : "";
      setSummaryText(translations("downloadProductsSummary", language).replace('${scenes}', downloads.length).replace('${mission}', missionText) + rateLimitText);
      setIsLoadingModalBody(false);
      setIsForbiddenSubmit(rateLimit !== null && ((rateLimit - downloads.length) < 0));
    }
    return () => {};
  }

  const proceedHandler = () => {
    setIsProceeding(true);
    if (downloads) {
      downloadProductsActionHandler(
        window,
        appParameters,
        downloads
      ).finally(() => {
        setIsProceeding(false);
        handleClose();
      });
    } else if (job) {
      const newJob: JobType = {...job};
      newJob.description = description;
      newJob.arguments = {...newJob.arguments, ...productionsFields}
      submitJobActionHandler(
          window,
          appParameters,
          newJob
      ).finally(() => {
        setIsProceeding(false);
        handleClose();
      });
    }
  };
  const hideHandler = () => {
    if (!isProceeding) {
      handleClose();
    }
  };

  let modalBody = <Loader />;

  if (!isLoadingModalBody) {
    modalBody = (
      <>
        {summaryText}

        {/* descrizione */}
        {job && (
          <div className="pt-2">
            <div className="row mx-0">
              <BootstrapForm.Label
                  className="m-0 px-0 d-flex col-3"
                  title="Description"
              >
                <span>{translations("descriptionCartModal", language)}</span>
              </BootstrapForm.Label>
              <BootstrapForm.Group
                  className="m-0 pr-0 col-9"
              >
                <InputText
                    disabled={false}
                    allowClear
                    name="description"
                    defaultValue={description}
                    onChange={(event) => setDescription(event.target.value)}
                />
              </BootstrapForm.Group>
            </div>
          </div>
        )}
        {/*cart name field end*/}

        {/* campi di produzione */}
        {job && productionFields && productionFields.length &&
            (
                <div
                  key={`job-processing-fields`}
                  className="job-processing-production-fields">
                  <p className="mb-2">{translations("jobInsertProductionParameters", language)}</p>
                  {productionFields.map(
                      (productionField) => (
                          <DynamicSearchField
                              key={`field-config-${productionField.name}`}
                              isProductionField={true}
                              configurations={configurations}
                              fieldConfigurations={productionField}
                              scopeConfigurationFields={scopeConfigurationFields}
                              selectedArea={selectedArea}
                              formProps={{
                                values: {
                                  ...searchFormAndSelectionValues,
                                },
                              }}
                              disabled={false}
                              appParameters={appParameters}
                          />
                      )
                  )}
                </div>
            )}
      </>
    );
  }

  const haveAllFieldsBeenFilled = haveProductionFieldsBeenFilled(
    configurations,
    appParameters,
    mainInputConfigurations,
    scopeConfigurationFields,
    selectedArea,
    searchFormValues,
    productionFields
  );

  return (
    <Modal show onHide={hideHandler} animation centered>
      <Modal.Header closeButton>
        <Modal.Title>{translations("summaryCheckoutModal", language)}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{modalBody}</Modal.Body>
      <Modal.Footer>
        <Button
          onClick={proceedHandler}
          disabled={isForbiddenSubmit || isProceeding || isLoadingModalBody || !haveAllFieldsBeenFilled}
        >
          {isProceeding ? (
            <Loader />
          ) : (
            <span>{translations("proceedCartModal", language)}</span>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  appParameters: state.application.appParameters,
  configurations: state.application.configurations,
  selectedArea: state.geoMap.lastShape,
  selectedProducts: state.product.selectedProducts,
  productionsFields: state.application.productionFiltersSelected,
  searchFormValues: {
    ...getSearchFormValuesByState(state),
    ...state.application.searchFiltersSelected,
    ...state.application.productionFiltersSelected
  },
  language: state.application.appParameters.language,
  searchByProducts: state.geoMap.searchByProducts,
  formData: state.application.formData,
});

const mapDispatchToProps = (dispatch) => ({
  downloadProductsActionHandler: (win, appParameters, downloads) =>
      dispatch(downloadProductsAction(win, appParameters, downloads)),
  submitJobActionHandler: (win, appParameters, job) =>
      dispatch(submitJobAction(win, appParameters, job))
});

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutModal);
